export const ROUTE_LIST_RESOURCES = '/list-resources';
export const ROUTE_RESOURCE_BUNDLE = '/resource-bundle';
export const ROUTE_TRANSLATE_RESOURCE = '/translate-resource';
